import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SidebarLink from './SidebarLink';
import SidebarLogout from '../SidebarLogout';
import TopImage from '../../../assets/LoginBackground.png';
import translations from '../../../services/translations/translations';

import '../../../style/layout/navbar/Sidebar.css';
import apiCommon from '../../../api/common';
import IVersion from '../../../api/interfaces/common/IVersion';

const Sidebar = ({
  isOpen,
  closeFunction,
}: {
  isOpen: boolean;
  closeFunction: (open: boolean) => void;
}): JSX.Element | null => {
  const [animate, setAnimate] = useState(false);
  const [version, setVersion] = useState('');
  const { t } = useTranslation(translations.common);
  const currentUser = useSelector((store: any) => store.users.current);

  const getSetVersion = async () => {
    const result: IVersion = await apiCommon.version.get();
    setVersion(result.buildNumber);
  };

  useEffect(() => {
    getSetVersion();
    setAnimate(true);
  }, []);

  const shouldSeeProjects =
    currentUser != null &&
    (currentUser.allowedToReadConfigurations ||
      currentUser.allowedToWriteOrganizationUnitProjects ||
      currentUser.allowedToWriteConfigurations);

  return (
    <>
      <div
        className={
          animate === false ? 'sidebar-content' : 'sidebar-content enter'
        }
      >
        <img src={TopImage} alt="" className="sidebar-image" />
        {shouldSeeProjects ? (
          <SidebarLink
            label={t('Projects')}
            link="/projects"
            sidebarClose={closeFunction}
          />
        ) : null}
        <a className="sidebar-link" href={currentUser.eworkbook}>
          <p className="sidebar-link-text">Eworkbook</p>
        </a>
        <SidebarLogout />
        <div style={{ marginLeft: '32px' }}>
          <p>Version: {version}</p>
        </div>
      </div>
      <div
        className={
          animate === false ? 'sidebar-outside' : 'sidebar-outside sidebar-dark'
        }
        onClick={() => closeFunction(false)}
        aria-hidden="true"
      />
    </>
  );
};

export default Sidebar;
